"use client";

import { useEffect, useState } from "react";
import { ArrowLeft, ArrowRight, Quote } from "lucide-react";
import { Button } from "@/components/ui/button";
export default function ConfianzaDeNuestrosClientes() {
  const testimonials = [{
    quote: "La disciplina y el profesionalismo de Poseidón han transformado nuestra percepción de seguridad. Su monitoreo constante nos brinda la tranquilidad necesaria para enfocarnos en el crecimiento de nuestra empresa.",
    firstName: "Ricardo",
    lastInitial: "M",
    profession: "Director Industrial, 52",
    treatment: "Seguridad Intramuros",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1697018/img/testimonio_ricardo_seguridad.png",
    imageSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1697018/img/testimonio_ricardo_seguridad.png-wvc-srcset",
    imageSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1697018/img/testimonio_ricardo_seguridad.png-wvc-sizes"
  }, {
    quote: "Implementar su sistema de videovigilancia avanzada fue la mejor decisión. La tecnología que manejan es de vanguardia y la respuesta de su centro de monitoreo es inmediata ante cualquier alerta.",
    firstName: "Elena",
    lastInitial: "V",
    profession: "Gerente de Logística, 45",
    treatment: "Tecnología y Monitoreo",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1697018/img/testimonio_elena_logistica.png",
    imageSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1697018/img/testimonio_elena_logistica.png-wvc-srcset",
    imageSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1697018/img/testimonio_elena_logistica.png-wvc-sizes"
  }, {
    quote: "El nivel de capacitación de sus guardias es notable. No solo es presencia física, es una estrategia integral de protección que se adapta perfectamente a las necesidades de nuestro corporativo.",
    firstName: "Carlos",
    lastInitial: "S",
    profession: "Administrador de Activos, 49",
    treatment: "Protección Ejecutiva",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1697018/img/testimonio_carlos_corporativo.png",
    imageSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1697018/img/testimonio_carlos_corporativo.png-wvc-srcset",
    imageSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1697018/img/testimonio_carlos_corporativo.png-wvc-sizes"
  }, {
    quote: "Poseidón trata la seguridad como una ciencia de precisión. La discreción, la claridad en sus protocolos y la atención personalizada son incomparables en el sector de seguridad privada.",
    firstName: "Sofía",
    lastInitial: "G",
    profession: "Directora de Operaciones, 38",
    treatment: "Consultoría en Riesgos",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1697018/img/testimonio_sofia_operaciones.webp",
    imageSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1697018/img/testimonio_sofia_operaciones.webp-wvc-srcset",
    imageSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1697018/img/testimonio_sofia_operaciones.webp-wvc-sizes"
  }];
  const [activeIndex, setActiveIndex] = useState(0);
  const [isFading, setIsFading] = useState(false);
  const goTo = (index: number) => {
    if (index === activeIndex) return;
    setIsFading(true);
    setTimeout(() => {
      setActiveIndex((index + testimonials.length) % testimonials.length);
      setIsFading(false);
    }, 350);
  };
  const handlePrev = () => goTo(activeIndex - 1);
  const handleNext = () => goTo(activeIndex + 1);
  useEffect(() => {
    const interval = setInterval(() => {
      setIsFading(true);
      setTimeout(() => {
        setActiveIndex(prev => (prev + 1) % testimonials.length);
        setIsFading(false);
      }, 350);
    }, 8000);
    return () => clearInterval(interval);
  }, [testimonials.length]);
  const current = testimonials[activeIndex];
  return <section data-section-id="5105" id="confianza-de-nuestros-clientes" className="bg-background text-foreground relative overflow-hidden py-20 md:py-28 lg:py-32 px-6 md:px-12 lg:px-20">
      {}
      <svg aria-hidden="true" className="pointer-events-none absolute left-0 right-0 top-1/2 -translate-y-1/2 w-full opacity-[0.06]" viewBox="0 0 1600 200" preserveAspectRatio="none">
        <path d="M0,100 L300,100 L340,100 L360,40 L390,160 L420,20 L450,180 L480,100 L800,100 L840,100 L860,40 L890,160 L920,20 L950,180 L980,100 L1600,100" fill="none" stroke="var(--primary)" strokeWidth="2" />
      </svg>

      {}
      <div className="absolute top-10 right-10 md:top-16 md:right-16 flex items-center justify-center">
        <span className="absolute inline-flex h-3 w-3 rounded-md opacity-75 animate-ping" style={{
        backgroundColor: "var(--primary)"
      }} />
        <span className="relative inline-flex h-2 w-2 rounded-md" style={{
        backgroundColor: "var(--primary)"
      }} />
      </div>

      <div className="relative max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-10 gap-12 lg:gap-16">
        {}
        <div className="lg:col-span-4 flex flex-col justify-between">
          <div>
            <p className="font-mono text-xs tracking-widest uppercase text-muted-foreground mb-6">
              § 04 / TESTIMONIOS
            </p>
            <h2 className="font-default font-bold text-foreground leading-[1.1] mb-8" style={{
            fontSize: "clamp(2.5rem, 5vw, 4rem)"
          }}>
              Confianza, <span className="font-light italic font-serif">recalibrada.</span>
            </h2>
            <p className="text-base md:text-lg text-muted-foreground font-default leading-relaxed max-w-md">
              Historias de éxito de clientes que han redefinido su tranquilidad a través de la precisión estratégica y tecnología de Grupo Poseidón.
            </p>
          </div>

          {}
          <div className="mt-12 lg:mt-16 flex items-center gap-6">
            <div className="flex items-center gap-3">
              <Button variant="outline" size="icon" onClick={handlePrev} aria-label="Previous testimonial" className="rounded-md border-border bg-transparent hover:bg-primary hover:text-primary-foreground hover:border-primary transition-all duration-300">
                <ArrowLeft className="h-4 w-4" />
              </Button>
              <Button variant="outline" size="icon" onClick={handleNext} aria-label="Next testimonial" className="rounded-md border-border bg-transparent hover:bg-primary hover:text-primary-foreground hover:border-primary transition-all duration-300">
                <ArrowRight className="h-4 w-4" />
              </Button>
            </div>

            <div className="flex items-center gap-2">
              {testimonials.map((_, i) => <Button key={i} data-index={i} onClick={() => goTo(i)} variant="ghost" size="sm" aria-label={`Go to testimonial ${i + 1}`} className="px-0 h-auto transition-all duration-500" style={{
              width: i === activeIndex ? "2.5rem" : "0.5rem",
              backgroundColor: "var(--primary)",
              opacity: i === activeIndex ? 1 : 0.3,
              borderRadius: "0px"
            }} />)}
            </div>

            <span className="font-mono text-xs text-muted-foreground ml-2">
              {String(activeIndex + 1).padStart(2, "0")} / {String(testimonials.length).padStart(2, "0")}
            </span>
          </div>
        </div>

        {}
        <div className="lg:col-span-6 relative">
          <div className={`relative bg-card rounded-md p-8 md:p-12 lg:p-14 shadow-xl transition-opacity duration-300 ${isFading ? "opacity-0" : "opacity-100"}`}>
            {}
            <Quote aria-hidden="true" className="absolute -top-8 -left-4 md:-top-10 md:-left-6 h-24 w-24 md:h-32 md:w-32 rotate-180 opacity-20" style={{
            color: "var(--primary)"
          }} strokeWidth={1} />

            <div className="relative pt-6 md:pt-8">
              <p className="font-serif italic font-light text-foreground leading-[1.4] mb-10" style={{
              fontSize: "clamp(1.25rem, 2.2vw, 1.75rem)"
            }}>
                "{current.quote}"
              </p>

              {}
              <div className="flex items-center gap-2 mb-8">
                <span className="h-1.5 w-1.5" style={{
                backgroundColor: "var(--primary)"
              }} />
                <span className="h-px flex-1 max-w-[80px]" style={{
                backgroundColor: "var(--border)"
              }} />
              </div>

              {}
              <div className="flex items-center gap-5">
                <img src={current.image} data-wvc-srcset={current.imageSrcset} data-wvc-sizes={current.imageSizes} alt={`${current.firstName} ${current.lastInitial}.`} loading="lazy" decoding="async" className="h-14 w-14 rounded-md object-cover border border-border grayscale hover:grayscale-0 transition-all duration-500" />
                <div className="flex flex-col gap-1">
                  <span className="text-base font-default font-semibold text-foreground">
                    {current.firstName} {current.lastInitial}.
                  </span>
                  <span className="text-[13px] italic text-muted-foreground font-serif">
                    {current.profession}
                  </span>
                  <span className="mt-1 inline-flex w-fit items-center px-3 py-0.5 text-[11px] font-mono uppercase tracking-wider rounded-sm" style={{
                  backgroundColor: "var(--primary)",
                  color: "var(--primary-foreground)"
                }}>
                    {current.treatment}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}